import { render } from "./ListeActualitePage.vue?vue&type=template&id=e8cc9ab8&ts=true"
import script from "./ListeActualitePage.vue?vue&type=script&lang=ts"
export * from "./ListeActualitePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__